import { Text, View } from '@react-pdf/renderer';

import { styles } from '../style';

const FinancialStatus = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Change in Financial Status of Buyer</Text>
      <Text style={styles.text}>
        1. If a change in{' '}
        <Text style={styles.bold}>Buyer’s financial status</Text> affects{' '}
        <Text style={styles.bold}>Buyer’s ability to purchase</Text>,{' '}
        <Text style={styles.bold}>Buyer</Text> will promptly notify{' '}
        <Text style={styles.bold}>Seller</Text> and lender(s) to whom the Buyer
        submitted a mortgage application, if any, in writing. A change in
        financial status includes, but is not limited to:
      </Text>
      <View style={styles.list}>
        <Text style={styles.listItem}>• Loss or a change in employment</Text>
        <Text style={styles.listItem}>
          • Failure or loss of sale of Buyer’s home
        </Text>
        <Text style={styles.listItem}>
          • Buyer having incurred a new financial obligation
        </Text>
        <Text style={styles.listItem}>• Entry of a judgment against Buyer</Text>
      </View>

      <Text style={styles.text}>
        <Text style={styles.bold}>Buyer</Text> understands that applying for
        and/or incurring an additional financial obligation may affect{' '}
        <Text style={styles.bold}>Buyer’s ability to purchase</Text>.
      </Text>
    </View>
  );
};

export default FinancialStatus;
